export default __webpack_public_path__ + "static/media/rocket-lunch 1.e57bdd65.svg";